import { DocumentSummary } from "./DocumentSummary";

export class DocumentSearchResult {
  summaries: DocumentSummary[];
  isExceededMaxRecordCountLimit: boolean;
}
